export class BackgroundDef {
  aspectFit: string;
  color = 'rgba(255, 255, 255, 0)';
  gradient?: string;
}
